import _ from 'lodash';
import Device from '../Device';

const questions = [{
  model: 'emporia',
  type: 'oauth',
  name: 'emporia',
  label: 'step3OauthDeviceEmporia',
  showNext: false,
  required: true,
  advanceOnEnter: true,
  advanceOnValue: true,
  update: values => ({
    additionalFields: {
      type: 'gravity',
      mfg: 'emporia',
      tags: JSON.stringify(_.get(values, 'tags') || {}),
      deviceTags: JSON.stringify(_.get(values, 'deviceTags') || {}),
    },
  }),
}];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const Emporia = new Device('emporia', { mfg: 'emporia', questions, addDevice });

export default Emporia;
